<template>
  <div class="field-maintenance-search">
    <v-alert v-if="error" type="error" dense outlined>{{ error }}</v-alert>

    <!-- N'importe quelle borne de son périmètre : par ce qu'il lit dessus ou par où elle est. -->
    <v-text-field
        v-model="search"
        :placeholder="$t('onboarding.field.maintenance.search')"
        prepend-inner-icon="mdi-magnify"
        outlined dense clearable hide-details
        background-color="white"
        autocapitalize="off" autocorrect="off" spellcheck="false"
        class="mb-5"
    />

    <h2 class="text-subtitle-1 font-weight-bold mb-3">{{ $t(searching ? 'onboarding.field.results' : 'onboarding.field.maintenance.installed') }}</h2>
    <div v-if="loading" class="text-center py-6"><v-progress-circular indeterminate color="primary" /></div>
    <p v-else-if="!chargingPoints.length" class="text-body-2 text--secondary">
      {{ $t(searching ? 'onboarding.field.maintenance.none-found' : 'onboarding.field.maintenance.none-installed') }}
    </p>

    <v-card
        v-for="chargingPoint in chargingPoints"
        :key="chargingPoint.id"
        class="mb-3"
        :to="{ name: 'field.charging-point', params: { id: chargingPoint.id } }"
    >
      <v-card-text class="pa-3">
        <div class="d-flex align-start">
          <div class="font-weight-bold text-body-1 text--primary">{{ chargingPoint.identifier }}</div>
          <v-spacer />
          <v-chip x-small :color="chargingPoint.connected ? 'success' : 'grey'" dark class="ml-2">
            {{ $t(chargingPoint.connected ? 'onboarding.field.maintenance.connected' : 'onboarding.field.maintenance.disconnected') }}
          </v-chip>
        </div>
        <div v-if="chargingPoint.name && chargingPoint.name !== chargingPoint.identifier" class="text-body-2">{{ chargingPoint.name }}</div>
        <div class="text-body-2">{{ chargingPoint.address || chargingPoint.locationName || $t('onboarding.commissioning.activation.no-location') }}</div>
        <div class="text-caption text--secondary">
          {{ chargingPoint.organizationName }}<span v-if="chargingPoint.serialNumber"> · {{ $t('onboarding.field.maintenance.serial', { serial: chargingPoint.serialNumber }) }}</span>
        </div>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import FieldRepository from '@repository/FieldRepository'
import CommissioningMixin from '../CommissioningMixin'

/**
 * La maintenance commence par trouver la borne : n'importe laquelle de son périmètre, par son identifiant, son numéro de
 * série, son nom, son adresse ou le client chez qui elle est. Sans recherche : celles qu'il a mises en service.
 */
export default {
  name: 'FieldMaintenanceSearch',

  mixins: [CommissioningMixin],

  data() {
    return { search: '', chargingPoints: [], loading: false, error: null, ticket: 0 }
  },

  computed: {
    /** Deux caractères au moins : une lettre seule ramène tout le parc. */
    searching() {
      return (this.search || '').trim().length >= 2
    },
  },

  watch: {
    search() {
      this.debouncedLoad()
    },
  },

  created() {
    this.debouncedLoad = debounce(this.load, 400)
    this.load()
  },

  methods: {
    async load() {
      // Une recherche partie avant la dernière frappe ne remplace pas la plus récente.
      const ticket = ++this.ticket
      this.loading = true
      this.error = null
      try {
        const result = await FieldRepository.chargingPoints(this.searching ? { search: this.search.trim() } : { mine: true })
        if (ticket !== this.ticket) return
        this.chargingPoints = result.chargingPoints || []
      } catch (e) {
        this.error = e?.response ? this.messageOf(e) : this.$t('onboarding.field.offline-list')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
